// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__BGjO5","item":"style_item__Ik0tL","button":"style_button__1xtdq"};